<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p>Many thanks to Chrystene Rae for designing the cover artwork.</p><br/>
<p style="text-indent:0em">Many thanks to Juliet Kim for rewriting the Korean dialogue.</p><br/>
<p style="text-indent:0em">Many thanks to Faye Yang for rewriting the Chinese dialogue.</p><br/>
<p style="text-indent:0em">Many thanks to the pilot readers for their feedback.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?2d73142c